(() => {
  const MEASUREMENT_ID = 'G-YFLTWWFDJW';

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const send = (name, params) => window.gtag('event', name, { ...params, send_to: MEASUREMENT_ID });

  const toItem = (item, index) => ({
    item_id: `shopify_US_${item.product_id}_${item.variant_id}`,
    item_name: item.product_title,
    item_variant: item.variant_title || undefined,
    price: item.final_price / 100,
    quantity: item.quantity,
    index,
  });

  const trackViewCart = () =>
    fetch(`${window.routes?.cart_url || '/cart'}.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (!cart.item_count) return;
        send('view_cart', {
          currency: cart.currency,
          value: cart.total_price / 100,
          items: cart.items.map(toItem),
        });
      })
      .catch(() => {});

  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    let isOpen = drawer.classList.contains('active');
    new MutationObserver(() => {
      const nowOpen = drawer.classList.contains('active');
      if (nowOpen && !isOpen) trackViewCart();
      isOpen = nowOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  const popup = { open: false, leadSubmitted: false };

  const readCookie = (name) => document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))?.[1];

  const gaIds = () => ({
    cid: readCookie('_ga')?.split('.').slice(2).join('.'),
    sid: readCookie(`_ga_${MEASUREMENT_ID.slice(2)}`)?.match(/^GS\d\.\d\.s?(\d+)/)?.[1],
  });

  const beaconEvent = (name) => {
    const { cid: clientId, sid: sessionId } = gaIds();
    if (!clientId || !navigator.sendBeacon) return false;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) return false;
    const query = new URLSearchParams({
      v: '2',
      tid: MEASUREMENT_ID,
      cid: clientId,
      en: name,
      dl: location.href,
      dt: document.title,
      seg: '1',
      _et: '1',
    });
    if (sessionId) query.set('sid', sessionId);
    return navigator.sendBeacon(`https://www.google-analytics.com/g/collect?${query}`);
  };

  const trackAgeGate = () => {
    const gate = document.getElementById('ageverification');
    if (!gate) return;
    document.addEventListener('ageverification:open', () => send('age_gate_view'));
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('#ageverification button.confirm')) send('age_gate_confirm');
    });
    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest?.('#ageverification button.deny')) return;
        event.stopPropagation();
        if (beaconEvent('age_gate_deny')) return window.redirect(false);
        let done = false;
        const go = () => {
          if (done) return;
          done = true;
          window.redirect(false);
        };
        send('age_gate_deny', { event_callback: go });
        setTimeout(go, 800);
      },
      true
    );
  };

  const trackRevi = () => {
    const isHost = (node) => node.id === 'revi-popup-host';
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (!popup.open && [...mutation.addedNodes].some(isHost)) {
          popup.open = true;
          popup.leadSubmitted = false;
          send('popup_view', { popup_provider: 'revi' });
        }
        if (popup.open && [...mutation.removedNodes].some(isHost)) {
          popup.open = false;
          send('popup_close', { popup_provider: 'revi', lead_submitted: popup.leadSubmitted });
        }
      });
    }).observe(document.body, { childList: true });

    const nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      const request = nativeFetch.apply(this, arguments);
      const url = typeof input === 'string' ? input : input?.url || '';
      const method = (init?.method || input?.method || 'GET').toUpperCase();
      if (method === 'POST' && url.endsWith('/widgets/leads')) {
        request
          .then((response) => {
            if (!response.ok) return;
            if (popup.open) popup.leadSubmitted = true;
            send('generate_lead', { method: 'revi-popup' });
          })
          .catch(() => {});
      }
      return request;
    };
  };

  const trackWhatsapp = () => {
    const pageType = () => {
      const path = location.pathname;
      if (path === '/') return 'home';
      if (path.startsWith('/products/')) return 'product';
      if (path.startsWith('/collections')) return 'collection';
      if (path.startsWith('/cart')) return 'cart';
      if (path.startsWith('/pages/')) return 'page';
      return 'other';
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('.whatsapp-flutuante a')) {
        send('whatsapp_click', { link_location: 'flutuante', page_type: pageType() });
      }
    });
  };

  let pendingSync = null;

  const syncGaIds = () => {
    if (pendingSync) return pendingSync;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) return Promise.resolve();
    const { cid, sid } = gaIds();
    if (!cid || !sid) return Promise.resolve();
    const cartUrl = window.routes?.cart_url || '/cart';
    pendingSync = fetch(`${cartUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (!cart.item_count) return;
        if (cart.attributes?._ga_cid === cid && cart.attributes?._ga_sid === sid) return;
        return fetch(`${cartUrl}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _ga_cid: cid, _ga_sid: sid } }),
        });
      })
      .catch(() => {})
      .then(() => {
        pendingSync = null;
      });
    return pendingSync;
  };

  const trackCartIds = () => {
    syncGaIds();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncGaIds);
    }
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('[name="checkout"], a[href*="/checkout"]')) syncGaIds();
    });
  };

  trackAgeGate();
  trackWhatsapp();
  trackCartIds();
  if (!document.querySelector('lead-form-revi')) trackRevi();
})();
